import React 		from 'react'
import classnames 	from 'classnames'

export default (props) => {
	const {
		icon,
		outlined,
		large,
		className
	} = props

	return <div
		className={ classnames('icon', {
			[`icon--t-${ icon }`]: icon,
			'icon--outlined': outlined,
			'icon--large': large
		}, className) } />
}